import { ArrowLeft } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface BackButtonProps {
  to?: string;
  fallback?: string;
  className?: string;
  children?: React.ReactNode;
  onBeforeNavigate?: () => boolean;
}

export function BackButton({
  to,
  fallback,
  className = "mb-4",
  children = "BACK",
  onBeforeNavigate
}: BackButtonProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    // If there's a before navigation callback, call it first
    if (onBeforeNavigate && !onBeforeNavigate()) {
      return;
    }

    if (to) {
      navigate(to);
    } else if (fallback && location.key === "default") {
      navigate(fallback);
    } else {
      navigate(-1);
    }
  };

  return (
    <Button
      variant="outline-on-light"
      onClick={handleClick}
      className={className}
    >
      <ArrowLeft className="h-4 w-4 mr-2" />
      {children}
    </Button>
  );
}
